import { DesignTokens, GivelifyLink, GivelifyPaper } from '@givelify/ui';
import { styled } from '@mui/material';

export const PageWrapper = styled('div')(() => ({
    background: DesignTokens.color.backgroundPrimary,
    position: 'fixed',
    overflow: 'auto',
    height: '100vh',
    width: '100vw',
    padding: '16px',
}));

export const HeaderWrapper = styled('div')(({ theme }) => ({
    paddingTop: '40px',
    paddingBottom: '80px',
    textAlign: 'center',
    [theme.breakpoints.down('mobile')]: {
        paddingBottom: '40px',
    },
}));

export const ContentWrapper = styled('div')(({theme}) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',

    [theme.breakpoints.down('mobile')]: {
        paddingBottom: '160px',
    }
}));

export const Container = styled(GivelifyPaper)(({ theme }) => ({
    width: '100%',
    maxWidth: '500px',
    padding: '40px',
    borderRadius: '32px',
    boxShadow: DesignTokens.shadow.shadowMedium,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '40px',
    marginBottom: '40px',

    [theme.breakpoints.down('mobile')]: {
        gap: '24px',
        marginBottom: '24px',
        padding: '24px',
    },
}));

export const InformationBox = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',

    '& .info': {
        textAlign: 'center',
        lineHeight: '32px',
    },

    '& .signed-up': {
        fontSize: '18px',
        fontWeight: 700,
        color: DesignTokens.color.textSecondary,
    },

    '& .check-email': {
        fontSize: '24px',
        fontWeight: 700,
        color: DesignTokens.color.textPrimary,
    },

    '& .confirmation': {
        fontSize: '16px',
        fontWeight: 600,
        lineHeight: '24px',
        color: DesignTokens.color.textSecondary,
        marginTop: '12px',
    },
}));

export const ConfirmationBox = styled('div')(({theme}) => ({
    width: '100%',
    textAlign: 'center',
    padding: '24px',
    borderRadius: '24px',
    background: DesignTokens.color.backgroundPrimary,

    '& .text': {
        fontSize: '16px',
        fontWeight: 600,
        color: DesignTokens.color.textPrimary,
    },
    '& .email': {
        fontSize: '16px',
        fontWeight: 800,
        color: DesignTokens.color.textPrimary,
        wordWrap: 'break-word'
    },

    [theme.breakpoints.down('mobile')]: {
        padding: '16px',
    }
}));

export const Link = styled(GivelifyLink)(() => ({
    fontWeight: 800,
    color: DesignTokens.color.globalNeutral700,

    '&:hover, &:active': {
        color: DesignTokens.color.globalNeutral700,
    },
}));

export const ActionRow = styled('div', {
    shouldForwardProp: (prop) => prop !== 'column',
})<{ column?: boolean }>(({ theme, column }) => ({
    display: 'flex',
    flexDirection: 'row',
    gap: '4px',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '4px',

    '& .text': {
        fontSize: '16px',
        lineHeight: '24px',
        color: DesignTokens.color.textSecondary,
    },
    [theme.breakpoints.down('mobile')]: {
        flexDirection: column ? 'column' : 'row',
    },
}));
